import { SelectChangeEvent } from "@mui/material"
import { action, makeAutoObservable } from "mobx"
import { nanoid } from "nanoid"
import { findParent } from "utils/dom"
import blockTypes from "../block-types"

class Block {

  id: string
  type: keyof(typeof blockTypes) = "value"
  position = { left: 0, top: 0 }
  data: { [ key: string ]: string } = {}
  emitters: string[] = []
  emittersPos = new Map<number, { top: number, left: number }>()
  collectorPos = { top: 0, left: 0 }

  constructor(id?: string) {
    this.id = id || nanoid(4)
    makeAutoObservable(this)
  }

  setChainPos(emitter: HTMLElement | null, index?: number) {
    if (!emitter) return
    const rect = emitter.getBoundingClientRect()
    const parentRect = findParent(emitter, el => el.hasAttribute('data-block-id'))!.getBoundingClientRect()
    const pos = { left: rect.left - parentRect.left + rect.width / 2, top: rect.top - parentRect.top + rect.height / 2}

    if (typeof index === "number") {
      this.emittersPos.set(index, pos)
    } else {
      this.collectorPos = pos
    }
  }

  setEmitters(emitters: string[]) {
    this.emitters = emitters
  }

  dataProps(key: string, defaultValue="") {
    return {
      value: this.data[key] || defaultValue,
      onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent) => {
        this.setData(key, e.target.value)
      }
    }
  }

  setData(key: string, value: any) {
    this.data[key] = value
  }

  checkboxProps(key: string, defaultValue = false) {
    return {
      checked: this.data[key]? (this.data[key] === "true"? true: false): defaultValue,
      onChange: action((e: React.ChangeEvent<HTMLInputElement>) => {
        this.data[key] = e.target.checked? "true": "false"
      })
    }
  }

}

export default Block